import React, { Component } from 'react';
import style from '../share/pageUpdate.module.css';
//import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import TextAreaWithLabel from '../../components/TextAreaWithLabel.js';

import DefaultBtn from '../../components/DefaultBtn.js';
import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';
import TemplateV2 from '../../components/TemplateV2';

import * as utils from '../../Utils.js';

class OpenApiUpdate extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            dataObject: null,
            validateObject: null,
            loading: true,
            companyId: this.props.match.params.id
        };
        //this.callGetData();
    }

    componentDidMount() {

        this.props.appState.checkUser(this.props.appState);

        //console.log(this.props.appState);

        this.callGetData();
    }
    callReissue() {
        //alert("xx");
        let appState = this.props.appState;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/ReissueOpenApi";
        let data = {};
        data.Id = appState.userObject.companyId;

        let token = appState.userObject.Token;
        utils.callPost(url,token,data,this.callReissueCallBack);

        this.setState({
            loading: true
        })
    }
    callReissueCallBack = (data) => {
        //console.log("callReissueCallBack");
        //console.log(data);

        let dataObject = this.state.dataObject;
        if (data.Success === true) {
            dataObject.Token = data.Data;
        }
        this.setState({
            dataObject: { ...dataObject },
            loading: false
        })
    }

    callGetData() {
        let userObject = this.props.appState.userObject;
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetOpenApiData";
        let appState = this.props.appState;
        let token = appState.userObject.Token;

        // let data = {
        //     Id: this.props.id
        // };
        let data = {};
        data.Id = userObject.companyId;
        utils.callPost(url,token,data,this.callGetDataCallBack);
        this.setState({
            loading: true
        })
    }
    callGetDataCallBack=(data)=> {
        this.setState({
            dataObject: { ...data.Data.dataObject },
            validateObject: { ...data.Data.validateObject },
            loading: false
        })
    }
    callSetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/UpdateOpenApi";
        let data = { ...this.state.dataObject };
        let appState = this.props.appState;
        let token = appState.userObject.Token;
        utils.callPost(url,token,data,this.callSetDataCallBack);

        this.setState({
            loading: true
        })
    }
    callSetDataCallBack=(data)=> {
        console.log(data);

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
                dataObject: { ...data.Data.dataObject },
                validateObject: { ...data.Data.validateObject }
            })
        }
    }
    handleChange = (e) => {
        console.log(e);
        let dataObject = this.state.dataObject;
        if (e.target.name === "Enable") dataObject.IsEnable = e.target.checked;
        //if (e.target.name === "HotelCode") dataObject.HotelCode = e.target.value;
        if (e.target.name === "Token") dataObject.Token = e.target.value;
        this.setState({
            dataObject: { ...dataObject },
        })
    }
    handleClick = (e) => {
        //alert("Update");
        console.log(e);
        if (e.target.name === "Update") {
            this.callSetData();
        }
        if (e.target.name === "Delete") {
            this.callDeleteData();
        }
        if (e.target.name === "Reissue") {
            this.callReissue();
        }
        if (e.target.name === "Cancel") {
            this.callGetData();
        }




        // if(method === "Update"){
        //     alert("Update");
        // }
    }

    // renderNameInput(dataObject, validateObject) {
    //     let item = [];

    //     //console.log("debug");
    //     //console.log(dataObject);

    //     for (let i = 0; i < dataObject.HotelNameList.length; i++) {
    //         let label = "Hotel Name (" + dataObject.HotelNameList[i].LanguageCode + ")";
    //         item.push(
    //             <div className={style.sectionInput} key={i}>
    //                 <TextBoxWithLabel name="Name" id={i} key={i} label={label} value={dataObject.HotelNameList[i].Name} errorMessage={validateObject.HotelNameList[i].Name} onChange={this.handleChange} />
    //             </div>
    //         );
    //     }
    //     return item;
    // }
    render() {
        let result = [];
        let dataObject = this.state.dataObject;
        let validateObject = this.state.validateObject;

        if (dataObject != null) {
            //let rowNameInput = this.renderNameInput(dataObject, validateObject);
            //alert(this.props.Id);
            result = (


                <TemplateV2 appState={this.props.appState} site={this.props.site} page={"company/openapi"}>

                    <div className={style.createArea}>
                        <BackDropLoading show={this.state.loading} />


                        <div className={style.navBar}>
                            <div className={style.nav}>Home</div>
                            <i className="fas fa-chevron-right"></i>
                            <div className={style.nav}>Company Detail</div>
                            <i className="fas fa-chevron-right"></i>
                            <div className={style.navSelect}>Open Api</div>

                        </div>




                        <div className={style.contentBox}>

                            {this.props.method === "Create" &&
                                <div className={style.contentTitle}>Create Affiliated Company</div>
                            }
                            {this.props.method === "Edit" &&
                                <div className={style.contentTitle}>Edit Open Api</div>
                            }
                            {this.props.method === "Delete" &&
                                <div className={style.contentTitle}>Delete Affiliated Company</div>
                            }






                            <div className={style.line}></div>
                            <div className={style.rowInput}>
                                <CheckBoxWithLabel name="Enable" label="Active" value={dataObject.IsEnable} errorMessage="" onChange={this.handleChange} />
                            </div>

                            <div className={style.sectionTextarea}>
                                <TextAreaWithLabel name="Token" label="Token" value={dataObject.Token} errorMessage={validateObject.Token} onChange={this.handleChange} />
                            </div>

                            <div className={style.primaryBoxBtn}>
                                <DefaultBtn label="Reissue" onClick={this.handleClick} name="Reissue" type="info" />
                            </div>



                            <div className={style.btnRow}>
                                <div className={style.btnRowCenter}>


                                    {this.props.method === "Create" &&
                                        <div className={style.primaryBoxBtn}>
                                            <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                        </div>
                                    }
                                    {this.props.method === "Edit" &&
                                        <div className={style.primaryBoxBtn}>
                                            <DefaultBtn label="Update" onClick={this.handleClick} name="Update" type="primary" />
                                        </div>
                                    }
                                    {this.props.method === "Delete" &&
                                        <div className={style.primaryBoxBtn}>
                                            <DefaultBtn label="Delete" onClick={this.handleClick} name="Delete" type="danger" />
                                        </div>
                                    }
                                    <div className={style.primaryBoxBtn}>
                                        <DefaultBtn label="Cancel" onClick={this.handleClick} name="Cancel" type="default" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </TemplateV2>



            );
        }
        return result;
    }
}
export default OpenApiUpdate;